"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _classname = _interopRequireDefault(require("./classname"));
var _NavigationButtonIcon = _interopRequireDefault(require("./NavigationButtonIcon"));
var _excluded = ["children", "className", "expandIcon", "fullWidth", "href", "url"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "navigationButtonWrapper": "nmU58-",
  "fullWidth": "NcAXBP"
};
var NavigationButton = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    expandIcon = _ref.expandIcon,
    fullWidth = _ref.fullWidth,
    href = _ref.href,
    url = _ref.url,
    props = _objectWithoutProperties(_ref, _excluded);
  var Tag = href ? 'a' : 'button';
  return /*#__PURE__*/_react["default"].createElement(Tag, _extends({
    ref: ref,
    className: (0, _clsx["default"])(className, _classname["default"].NAVIGATION_BUTTON, styles.navigationButtonWrapper, fullWidth && styles.fullWidth),
    href: href,
    url: url
  }, props), children, expandIcon && /*#__PURE__*/_react["default"].createElement(_NavigationButtonIcon["default"], null));
});
NavigationButton.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  expandIcon: _propTypes["default"].bool,
  fullWidth: _propTypes["default"].bool,
  href: _propTypes["default"].string,
  url: _propTypes["default"].string
} : {};
var _default = exports["default"] = NavigationButton;